import { useEvaluatorAuthStore } from "./evaluatorAuthStore";

/**
 * Hook de déconnexion du portail évaluateur.
 *
 * Vide le store d'authentification (clé "evaluator-auth") et recharge la page.
 * La modale de saisie réapparaît automatiquement car le token est vide.
 *
 * @example
 * ```tsx
 * const { logout } = useEvaluatorLogout();
 * <Navbar onLogout={logout} />
 * ```
 */
export function useEvaluatorLogout() {
  const clear = useEvaluatorAuthStore((state) => state.clear);

  const logout = () => {
    clear();
    window.location.reload();
  };

  return { logout };
}
